<template>
  <div>
    <v-chip
      v-for="(skill, index) in skills"
      :key="index"
      small
      outlined
      class="mb-1"
      :class="index + 1 !== skills.length ? 'mr-1' : ''"
      :ripple="false"
    >
      <span v-if="showBadges">
        <v-img
          v-if="skill.badgeUrl.size200x200"
          :src="skill.badgeUrl.size200x200"
          contain
          height="20px"
          width="28px"
        ></v-img>
        <v-icon v-else small :color="skill.group.color"
          >mdi-{{ skill.group.icon }}</v-icon
        >
      </span>
      <span v-else>{{ skill.shortTitle }}</span>
    </v-chip>
    <!-- <div v-if="skills.length > 0" class="mt-2">
      <v-card outlined class="text-center" max-width="430px">
        <v-row no-gutters>
          <v-col v-for="(skill, index) in skills" :key="index">{{
            skill.shortTitle
          }}</v-col>
        </v-row>
      </v-card>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "personnel-record-skill-set",
  components: {},
  props: {
    skills: {
      type: Array,
      required: true,
    },
    showBadges: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
